import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { LogoMark } from "../components/store/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("gifts_admin_token", r.data.token);
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-[80vh] items-center justify-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm space-y-4 rounded-3xl border border-white/[0.07] bg-[#1a1633] p-8">
        <LogoMark className="h-12 w-12" />
        <h1 className="font-display text-2xl font-semibold text-white">Admin login</h1>
        <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="field" />
        <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="field" />
        {err && <p data-testid="admin-login-error" className="text-sm text-rose-400">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="btn-primary w-full">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}</button>
      </form>
    </main>
  );
}
